<template>
  <div class="report-section report-section-header">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <dashboard-card
      ref="dashboardCard"
      isTemplate
      :panel="panel"
      :extraParams="extraParams"
      :time="time"
      :timeGroup="timeGroup"
      @fetchDataSuccess="handleMonitorFetchSuccess" />
  </div>
</template>

<script>
import DashboardCard from '@Monitor/components/MonitorCard/DashboardCard'

export default {
  name: 'ReportAccountBalance',
  components: {
    DashboardCard,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
    reportType: {
      type: String,
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const model = {
      measurement: 'cloudaccount_balance',
      database: 'meter_db',
      interval: '24h',
      select: [
        [
          {
            type: 'field',
            params: ['balance'],
          },
        ],
      ],
    }
    const tags = model.tags || []
    // if (this.scopeParams.project_id) {
    //   tags.push({
    //     key: 'project_id',
    //     value: this.scopeParams.project_id,
    //     operator: '=',
    //   })
    // }
    if (this.scopeParams.domain_id) {
      tags.push({
        key: 'domain_id',
        value: this.scopeParams.domain_id,
        operator: '=',
      })
    }
    if (tags.length) {
      model.tags = tags
    }

    // 计算时间参数
    let from, to, time
    if (this.reportType === 'month') {
      // 月报：计算上个月的时间范围
      const now = this.$moment()
      const lastMonthStart = this.$moment().subtract(1, 'month').startOf('month') // 上个月1号0点
      const lastMonthEnd = this.$moment().subtract(1, 'month').endOf('month') // 上个月最后一天最后一刻

      // from: 当前时间距离上个月1号0点多少个小时
      const fromHours = now.diff(lastMonthStart, 'hours')
      // to: 当前时间距离上个月最后一天最后一刻多少个小时
      const toHours = now.diff(lastMonthEnd, 'hours')
      // time: 上个月的总小时数（上个月最后一天最后一刻 - 上个月1号0点）
      const timeHours = lastMonthEnd.diff(lastMonthStart, 'hours')

      from = `${fromHours}h`
      to = `${toHours}h`
      time = `${timeHours}h`
    } else {
      // 日报：保持原状
      from = '720h'
      to = 'now'
      time = '720h'
    }

    return {
      extraParams: {
        scope: this.$store.getters.scope,
      },
      panel: {
        panel_name: this.$t('monitor_metric_76'),
        queryData: {
          scope: this.$store.getters.scope,
        },
        setting: {
          conditions: [
            {
              operator: '=',
              type: 'query',
              query: {
                from,
                to,
                model,
              },
            },
          ],
        },
      },
      time,
      timeGroup: '24h',
    }
  },
  methods: {
    getTemplateParams () {
      return {}
    },
    handleMonitorFetchSuccess () {
      if (this.isTemplateEdit) return
      const card = this.$refs.dashboardCard
      this.$emit('resourceListHidden', this.isMonitorDataEmpty(card))
    },
    isMonitorDataEmpty (card) {
      if (!card) return true
      const series = card.series || []
      const hasPoints = series.some(s => Array.isArray(s.points) && s.points.length > 0)
      if (hasPoints) return false
      const reduced = card.reducedResult || {}
      const hasReduced = Object.keys(reduced).some((key) => {
        const val = reduced[key]
        return Array.isArray(val) ? val.length > 0 : val != null && val !== ''
      })
      if (hasReduced) return false
      return (card.pager?.total ?? 0) === 0
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
